import * as fonts from "./fonts";
import * as colors from "./colors";

import facepaint from "facepaint";
import * as R from "ramda";

import { shevy } from "./typography";
import { useMedia } from './useMedia'

import { borderRadius } from "polished";

export const mq = facepaint([
  "@media(min-width: 520px)",
  "@media(min-width: 920px)",
  "@media(min-width: 1120px)",
]);

export const roundedFirstItem = {
  ...borderRadius("top", [5, 32]),
  margin: [12, 0],
  marginTop: 0,
  marginBottom: 0,
};

export const theme = {
  colors: {
    ...colors,
  },
  breakpoints: [32, 48, 64, 80, 96],
  fontWeights: {
    thin: "100",
    light: "200",
    regular: "300",
    medium: "400",
    semibold: "500",
    bold: "600",
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 72],
  radii: [0, 4, 8, 12, 16, 32],
  space: [0, 8, 16, 32, 64, 96, 128],
  shadows: [
    undefined,
    "0 0 8px rgba(0, 0, 0, .125)",
    "0 0 8px rgba(0, 0, 0, .25)",
  ],
};

export const defaultTheme = "orange";

export const themeColor = (name, semiTransparent) =>
  R.pipe(
    R.unless(
      R.isNil,
      R.pipe(
        R.toLower(),
        R.when(R.always(semiTransparent), R.concat(R.__, "Transparent"))
      )
    )
  )(name || defaultTheme);

export { colors, fonts, shevy, useMedia };



// WEBPACK FOOTER //
// ./src/styles/index.js